import { AutogenModelRecurringAvailableTractor, AutogenRowRecurringAvailableTractor } from "./autogen/AutogenModelRecurringAvailableTractor";

export class ModelRecurringAvailableTractor extends AutogenModelRecurringAvailableTractor<RowRecurringAvailableTractor> {
	constructor() {
		super(RowRecurringAvailableTractor);
	}
}

export class RowRecurringAvailableTractor extends AutogenRowRecurringAvailableTractor {
}